import React, { useMemo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import { useSearchUrlGenerator } from "@/hooks/useSearchUrlGenerator";
import pick from "lodash/pick";

const Filter = ({ params, query, queryKey, title }) => {
  const urlGenerator = useSearchUrlGenerator();
  const { link, isActive } = useMemo(() => {
    // https://trello.com/c/Bm2KA1Ow
    let finalQuery = pick(query, [
      "lat",
      "lng",
      "address_label",
      "radius",
      "spec",
    ]);
    let isActive;
    if (queryKey === "price") {
      isActive = query.sort === "price";
      finalQuery.sort = !isActive && "price";
    } else if (queryKey === "rate") {
      isActive = query.sort === "-rate";
      finalQuery.sort = !isActive && "-rate";
    } else {
      isActive = query[queryKey];
      finalQuery[queryKey] = !isActive;
    }
    return {
      link: urlGenerator({
        params,
        query: finalQuery,
      }),
      isActive,
    };
  }, [params, query, queryKey]);
  return (
    <S.Item>
      <S.Link to={link} $isActive={isActive}>
        {title}
      </S.Link>
    </S.Item>
  );
};
Filter.propTypes = {
  queryKey: PT.string.isRequired,
  title: PT.string.isRequired,
  params: PT.object.isRequired,
  query: PT.object.isRequired,
};
export default Filter;
